"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MP3_FEATURE_ENABLED = void 0;
// 기능 플래그 모음
//
// MP3_FEATURE_ENABLED: B2(대인라 260602 p.3) — mp3 첨부 허용 + 파일첨부형 테스트 오디오 플레이어.
//   mp3 첨부 허용 요청으로 활성화(2026-06-24). 끄려면 false 로 변경.
//   (관련 코드는 이 플래그로 게이트:
//    FileInput.tsx mp3 확장자/MIME, AttachFile.tsx·AttachFileAnswer.tsx accept,
//    AttachmentQuestionTable.tsx 오디오 플레이어 렌더)
exports.MP3_FEATURE_ENABLED = true;
